import React, { useState, useEffect } from 'react';
import UserSelectField from '../DebateArena/UserSelectField/UserSelectField';
import styles from './DebaterAssign.module.css';


const ModeratorAssignCache = ({
  arena,
  custom,
  roles,
  currentUser,
  cache,
  setCache,
  resetSlots,
  setSearchTarget,
  setSearchTargetTeam,
  handleUserSelect
}) => {
  const [normalizedDebaters, setNormalizedDebaters] = useState(null);

  // Run setup only when data is ready
  useEffect(() => {
	  if (!roles) return;

	  setNormalizedDebaters(roles.moderator);
	}, [roles]);

  return (
    <div className={styles.debaterAssign}>
	<div className={`${styles.teamSection} ${styles["neutral"]}  ${styles["moderatorstyle"]}`}>
		<UserSelectField
		  cache={cache}
		  setCache={setCache}
		  currentUser={currentUser}
		  handleUserSelect={handleUserSelect}
		  isAutoSelect={false}
		  setSearchTarget={setSearchTarget}
		  label="Moderator"
		  selected={normalizedDebaters}
		  onPickUser={() => setSearchTarget('mod')}
		  isCurrentUser={normalizedDebaters?.uid === currentUser.uid}
		  onSelect={(user) => {
			//setNormalizedDebaters(user);
			handleUserSelect(true, user, 0, undefined, arena, null);
		  }}/>
	</div>
	</div>
  );
};

export default ModeratorAssignCache;
